module.exports = __webpack_public_path__ + "static/img/1018_small.a7c96c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1018_small.png
// module id = kfaD
// module chunks = 1